import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { INTEGRATIONS_PATH } from '../../lib/setup.ts';
import { PRIMARY_BUTTON } from './styles.ts';

type Variant = 'card' | 'chat' | 'inline';

const WRAPPER: Record<Variant, string> = {
  card: 'rounded-xl bg-(--color-bg-secondary) border border-(--color-accent)/40 p-5 flex flex-col items-start gap-3',
  chat: 'max-w-3xl mx-auto mb-2 rounded-lg bg-(--color-accent)/10 border border-(--color-accent)/30 px-3 py-2 flex flex-wrap items-center justify-between gap-2',
  inline: 'flex flex-col items-start gap-2 py-4',
};

/**
 * The "connect your device" call to action shown wherever there are no
 * rides yet: Chat (above the input), Dashboard, Fitness, Training blocks.
 * Goes to Profile → Integrations.
 */
export function NoRidesCallout({ variant = 'card' }: Readonly<{ variant?: Variant }>) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const body = variant === 'chat' ? t('setup.noRides.chat') : t('setup.noRides.body');
  return (
    <section aria-label={t('setup.noRides.title')} className={WRAPPER[variant]}>
      {variant === 'card' && (
        <h2 className="text-base font-semibold text-(--color-text-primary)">{t('setup.noRides.title')}</h2>
      )}
      <p className={variant === 'chat' ? 'text-xs flex-1' : 'text-sm text-(--color-text-secondary)'}>{body}</p>
      <button type="button" onClick={() => navigate(INTEGRATIONS_PATH)} className={PRIMARY_BUTTON}>
        {t('setup.noRides.connect')}
      </button>
    </section>
  );
}
